import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

interface AdminRouteProps {
  children: ReactNode;
}

const ADMIN_ROLES = ['admin', 'owner'];

export function AdminRoute({ children }: AdminRouteProps): ReactNode {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user || !ADMIN_ROLES.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
